import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

/**
 * Chave do `state` da navegação com os motivos de não elegibilidade (GET /v1/requerimentos/home, tp_elegibilidade N).
 * Só o fluxo do requerimento a envia; nos demais a tela segue com a mensagem de token.
 */
export const MOTIVOS_NAO_ELEGIVEL_STATE = 'motivosNaoElegivel';

@Component({
  imports: [],
  selector: 'app-token-invalido',
  styleUrl: './token-invalido.scss',
  templateUrl: './token-invalido.html',
})
export class TokenInvalido {
  /** Motivos de não elegibilidade recebidos do fluxo do requerimento; vazio nos demais fluxos. */
  readonly motivosNaoElegivel: string[] = lerMotivos(
    inject(Router).currentNavigation()?.extras.state ?? history.state,
  );
}

function lerMotivos(state: Record<string, unknown> | null | undefined): string[] {
  const motivos = state?.[MOTIVOS_NAO_ELEGIVEL_STATE];
  return Array.isArray(motivos) ? motivos.filter((motivo): motivo is string => typeof motivo === 'string') : [];
}
